import { useSelector } from "react-redux";

import useCheckWorkspacePermission from "src/hooks/useCheckWorkspacePermission";
import { RootState } from "src/redux/reducers";

export const useHasAccessAndIsEnabledCreatorSearch = (): boolean => {
  const hasAccessToCreatorDiscovery =
    useCheckWorkspacePermission("CREATOR_DISCOVERY");

  const identity = useSelector(
    (state: RootState) => state.mainReducer.identity,
  );

  const isCreatorSearchEnabled = identity?.isCreatorSearchEnabled;

  return Boolean(hasAccessToCreatorDiscovery && isCreatorSearchEnabled);
};
